import { types } from "../../types/types";

const initialState = {
  afiliadoSeleccionado: null,
  efectorSeleccionado: null,
  estadoComprobantes: null,   //LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA?.toString(),
  contadores: [],
  comprobantes: [],
  comprobanteSeleccionado: null,
  trackingLineaComprobante: [],
  comprobantesTomados: [],
  comprobantesTomadosUsuario: [],
  lineasInsumosComprobante: [],
  lineasMedicamentosComprobante: [],
  lineasPrestacionComprobante: [],
  motivosDebito: [],
  tipoDocumentacion: null,
  DocumentacionPorId: []
};

export const liquidacionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.liquidacionesClearReducer:
      return {
        ...initialState,
      };
    case types.liquidacionesUpdateEstadoComprobantes:
      return {
        ...state,
        estadoComprobantes: action.payload,
      };
    case types.liquidacionesSetEfectorSeleccionado:
      return {
        ...state,
        efectorSeleccionado: action.payload,
      };
    case types.liquidacionesCleanEfectorSeleccionado:
      return {
        ...state,
        efectorSeleccionado: null,
      };
    case types.liquidacionesSetAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: action.payload,
      };
    case types.liquidacionesCleanAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: null,
      };
    case types.liquidacionesGetComprobantesSuccess:
      return {
        ...state,
        comprobantes: action.payload,
      };
    case types.liquidacionesCleanComprobantes:
      return {
        ...state,
        comprobantes: [],
      };
    case types.liquidacionesGetComprobantesError:
      return {
        ...state,
        comprobantes: [],
      };
    case types.liquidacionesGetComprobantesContadoresError:
      return {
        ...state,
        contadores: [],
        comprobantes: [],
      };
    case types.liquidacionesGetContadoresComprobantesSuccess:
      return {
        ...state,
        contadores: action.payload,
      };
    case types.liquidacionesGetContadoresComprobantesError:
      return {
        ...state,
        contadores: [],
      };
    //COMPROBANTE SELECCIONADO
    case types.liquidacionesSetComprobanteSeleccionado:
      return {
        ...state,
        comprobanteSeleccionado: action.payload,
      };
    case types.liquidacionesUpdateComprobanteSeleccionado:
      return {
        ...state,
        comprobanteSeleccionado: action.payload,
      };
    case types.liquidacionesCleanComprobanteSeleccionado:
      return {
        ...state,
        comprobanteSeleccionado: null,
      };
    case types.liquidacionesUpdateEstadoComprobanteSeleccionado:
      return {
        ...state,
        comprobanteSeleccionado: null,
        comprobantes: state.comprobantes.filter(
          (item) => item.idComprobante !== action.payload.idComprobante
        ),
        // contadores: state.contadores.map((item) =>
        //   item.idEstado === action.payload.idNuevoEstado 
        //     || item.idEstado === action.payload.idEstadoAnterior
        //     ? {
        //         ...item,
        //         total: item.idEstado === action.payload.idNuevoEstado ? item.total + 1 : item.total - 1
        //       }
        //     : item
        // ),
      };
    case types.liquidacionesUpdateEmailEfectorComprobanteSeleccionado:
      return {
        ...state,
        comprobanteSeleccionado: {
          ...state.comprobanteSeleccionado,
          comprobanteContrato: {
            ...state.comprobanteSeleccionado.comprobanteContrato,
            emailEfector: action.payload.emailEfector
          }
        },
        comprobantes: state.comprobantes.map((item) =>
          item.idComprobante === action.payload.idComprobante
            ? {
              ...item,
              emailEfector: action.payload.emailEfector
            }
            : item
        ),
      };
    //TOTAL LINEAS COMPROBANTE
    case types.liquidacionesUpdateTotalDebitosLineasComprobanteSeleccionado:
      return {
        ...state,
        comprobanteSeleccionado: { ...state.comprobanteSeleccionado, totalDebitosLineasComprobante: action.payload }
      };
    case types.liquidacionesUpdateTotalLineasComprobanteSeleccionado:
      return {
        ...state,
        comprobanteSeleccionado:
        {
          ...state.comprobanteSeleccionado,
          totalLineasComprobante: action.payload.totalImporteLineas,
          totalDebitosLineasComprobante: action.payload.totalImporteDebitos,
          idsSolicitudesLiquidaciones: action.payload.idsSolicitudesLiquidaciones
        }
      };
    //LINEA PRESTACION
    case types.liquidacionesGetLineasPrestacionComprobanteSuccess:
      return {
        ...state,
        lineasPrestacionComprobante: action.payload,
      };
    case types.liquidacionesAddLineaPrestacionComprobante:
      return {
        ...state,
        lineasPrestacionComprobante: [...state.lineasPrestacionComprobante, action.payload],
      };
    case types.liquidacionesUpdateLineaNuevaPrestacionComprobante:
      return {
        ...state,
        lineasPrestacionComprobante: state.lineasPrestacionComprobante.map((item) =>
          item.newLine && item.idCodNom === action.payload.idCodNom
            ? action.payload
            : item
        ),
      };
    case types.liquidacionesDeleteLineaPrestacionComprobante:
      return {
        ...state,
        lineasPrestacionComprobante: state.lineasPrestacionComprobante.filter(
          (item) => item.idItem !== action.payload
        ),
      };
    case types.liquidacionesUpdateLineaPrestacionComprobante:
      return {
        ...state,
        lineasPrestacionComprobante: state.lineasPrestacionComprobante.map((item) =>
          item.idItem === action.payload.idItem
            ? action.payload
            : item
        ),
      };
    case types.liquidacionesCleanLineasPrestacionComprobante:
      return {
        ...state,
        lineasPrestacionComprobante: [],
      };
    case types.liquidacionesGetLineasPrestacionError:
      return {
        ...state,
        lineasPrestacionComprobante: [],
      };
    //LINEA INSUMOS
    case types.liquidacionesGetLineasInsumosComprobanteSuccess:
      return {
        ...state,
        lineasInsumosComprobante: action.payload,
      };
    case types.liquidacionesAddLineaInsumoComprobante:
      return {
        ...state,
        lineasInsumosComprobante: [...state.lineasInsumosComprobante, action.payload],
      };
    case types.liquidacionesUpdateLineaNuevaInsumoComprobante:
      return {
        ...state,
        lineasInsumosComprobante: state.lineasInsumosComprobante.map((item) =>
          item.newLine && item.idMaterial === action.payload.idMaterial
            ? action.payload
            : item
        ),
      };
    case types.liquidacionesUpdateLineaInsumoComprobante:
      return {
        ...state,
        lineasInsumosComprobante: state.lineasInsumosComprobante.map((item) =>
          item.idItem === action.payload.idItem
            ? action.payload
            : item
        ),
      };
    case types.liquidacionesDeleteLineaInsumoComprobante:
      return {
        ...state,
        lineasInsumosComprobante: state.lineasInsumosComprobante.filter(
          (item) => item.idItem !== action.payload
        ),
      };

    case types.liquidacionesCleanLineasInsumosComprobante:
      return {
        ...state,
        lineasInsumosComprobante: [],
      };
    case types.liquidacionesGetLineasInsumosError:
      return {
        ...state,
        lineasInsumosComprobante: [],
      };
    //LINEA MEDICAMENTO
    case types.liquidacionesUpdateLineaNuevaMedicamentoComprobante:
      return {
        ...state,
        lineasMedicamentosComprobante: state.lineasMedicamentosComprobante.map((item) =>
          item.newLine && item.idMaterial === action.payload.idMaterial
            ? action.payload
            : item
        ),
      };
    case types.liquidacionesAddLineaMedicamentoComprobante:
      return {
        ...state,
        lineasMedicamentosComprobante: [...state.lineasMedicamentosComprobante, action.payload],
      };
    case types.liquidacionesUpdateLineaMedicamentoComprobante:
      return {
        ...state,
        lineasMedicamentosComprobante: state.lineasMedicamentosComprobante.map((item) =>
          item.idItem === action.payload.idItem
            ? action.payload
            : item
        ),
      };
    case types.liquidacionesDeleteLineaMedicamentoComprobante:
      return {
        ...state,
        lineasMedicamentosComprobante: state.lineasMedicamentosComprobante.filter(
          (item) => item.idItem !== action.payload
        ),
      };



    case types.liquidacionesGetLineasMedicamentosComprobanteSuccess:
      return {
        ...state,
        lineasMedicamentosComprobante: action.payload,
      };
    case types.liquidacionesCleanLineasMedicamentosComprobante:
      return {
        ...state,
        lineasMedicamentosComprobante: [],
      };
    case types.liquidacionesGetLineasMedicamentosError:
      return {
        ...state,
        lineasMedicamentosComprobante: [],
      };
    //COMPROBANTES TOMADOS
    case types.liquidacionesComprobanteMarcarTomado:
      return {
        ...state,
        comprobantes: state.comprobantes.map((item) =>
          item.idComprobante === action.payload.comprobante.idComprobante
            ? {
              ...item,
              comprobantesTomados: [
                {
                  id: action.payload.id,
                  usuarioTomado: { userName: action.payload.auth.userName },
                  idUsuarioTomado: action.payload.auth.idUsuario,
                },
              ],
            }
            : item
        ),
      };
    case types.liquidacionesComprobantesTomadosUsuarioSuccess:
      return {
        ...state,
        comprobantesTomadosUsuario: action.payload,
      };
    case types.liquidacionesComprobantesTomadosUsuarioLiberar:
      return {
        ...state,
        comprobantesTomadosUsuario: state.comprobantesTomadosUsuario.filter(
          (item) => item.id !== action.payload
        ),
      };
    case types.comprobantesTomadosLiberarTomadoPorIdComprobante:
      return {
        ...state,
        comprobantes: state.comprobantes.map((item) =>
          item.idComprobante === action.payload
            ? {
              ...item,
              comprobantesTomados: [],
            }
            : item
        ),
      };
    case types.liquidacionesComprobantesTomadosUsuarioAgregar:
      return {
        ...state,
        comprobantesTomadosUsuario: [
          ...state.comprobantesTomadosUsuario,
          action.payload,
        ],
      };
    case types.liquidacionesComprobantesTomadosUsuarioError:
      return {
        ...state,
        comprobantesTomadosUsuario: [],
      };
    case types.liquidacionesComprobantesTomadosSuccess:
      return {
        ...state,
        comprobantesTomados: action.payload,
      };
    case types.liquidacionesComprobantesTomadosLiberar:
      return {
        ...state,
        comprobantesTomados: state.comprobantesTomados.filter(
          (item) => item.id !== action.payload
        ),
      };
    case types.liquidacionesComprobantesTomadosError:
      return {
        ...state,
        comprobantesTomados: [],
      };
    case types.liquidacionesComprobantesTomadosLimpiar:
      return {
        ...state,
        comprobantesTomados: [],
        comprobantesTomadosUsuario: [],
      };
    //TRACKING LINEA COMPROBANTE
    case types.trackingLineaComprobanteSuccess:
      return {
        ...state,
        trackingLineaComprobante: action.payload,
        loading: false
      };
    case types.trackingLineaComprobanteError:
      return {
        ...state,
        trackingLineaComprobante: [],
        loading: false
      };
    case types.liquidacionesUpdateComprobanteContrato:
      debugger
      return {
        ...state,
        comprobanteSeleccionado: {
          ...state.comprobanteSeleccionado,
          comprobanteContrato: {
            ...action.payload.comprobanteContrato // Aquí actualizas todo el objeto comprobanteContrato
          }
        },
      };
    case types.liquidacionesGetMotivosDebitoSuccess:
      return {
        ...state,
        motivosDebito: action.payload,
      };
    case types.getTiposDocumentacionLiqui:
      return {
        ...state,
        tipoDocumentacion: action.payload
      }
    case types.getDocumentacionXIdExpedienteLiqui:
      return {
        ...state,
        DocumentacionPorId: action.payload,
        loading: false
      }
    default:
      return state;
  }

};


